// src/components/MapPinLocation.tsx
import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-control-geocoder";

// Optional: Custom icon
const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

// Komponen untuk menangani klik di peta
const LocationMarker = ({ onSelect }) => {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      onSelect({ lat, lng });
    },
  });
  return null;
};

// Komponen untuk search lokasi menggunakan Geocoder
const LocationSearchControl = () => {
  const map = useMap();

  useEffect(() => {
    const geocoder = (L.Control as any).geocoder({
      defaultMarkGeocode: false,
    })
      .on("markgeocode", function (e: any) {
        const { center } = e.geocode;
        map.setView(center, 16);
        // L.marker(center, { icon: markerIcon }).addTo(map);
      })
      .addTo(map);

    return () => map.removeControl(geocoder);
  }, [map]);

  return null;
};
// Komponen untuk auto-recenter saat lat/lng berubah
const RecenterMap = ({ lat, lng }) => {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) {
      map.setView([lat, lng], 13); // Atur zoom sesuai kebutuhan
    }
  }, [lat, lng, map]);
  return null;
};

const MapPinLocation = ({ latitude, longitude, onSelect, disabled = false }) => {

  const parsedLat = parseFloat(latitude);
  const parsedLng = parseFloat(longitude);
  const position =
    latitude && longitude
      ? [parseFloat(latitude), parseFloat(longitude)]
      : [-6.2088, 106.8456]; // Jakarta default

  return (
    <MapContainer
      center={position}
      zoom={13}
      scrollWheelZoom={true}
      style={{ height: 300, width: "100%", borderRadius: "8px" }}
    >
      <TileLayer
        attribution='© <a href="http://osm.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* <LocationSearchControl /> */}
      {!disabled && <LocationMarker onSelect={onSelect} />}
      {latitude && longitude && (
        <><Marker position={[parseFloat(latitude), parseFloat(longitude)]} icon={markerIcon} />
        <RecenterMap lat={parsedLat} lng={parsedLng} /></>
      )}
    </MapContainer>
  );
};

export default MapPinLocation;
